import { render, staticRenderFns } from "./GroupEdit.vue?vue&type=template&id=9cc5bbc8&scoped=true&lang=html&"
import script from "./GroupEdit.vue?vue&type=script&lang=js&"
export * from "./GroupEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cc5bbc8",
  null
  
)

export default component.exports